import axios from "axios"
import api from "../../../api";
import { requestID, config } from "../../../common/utils";
// import api from "../../api"

// import { baseUrl, config, requestID } from "../../common/utils"





export interface Employee {
  id: string;
  name: string;
  balance: number;
  contact?: string;
  details?: string;
    last_updated?: string;
    user_id?: string; // Optional for staff
    userName?: string; // Optional for staff
    department?: string; // Optional for staff
    position?: string; // Optional for staff
    email?: string; // Optional for staff
    phone?: string; // Optional for staff
    firstName?: string; // Optional for staff
    lastName?: string; // Optional for staff
    amount?: number; // Optional for staff
    ledgerbal?: number; // Optional for staff
}
export interface Customer {
  id: string;
  name: string;
  balance: number;
  contact?: string;
  details?: string;
  lastTransactionDate?: string;
}



export interface Vendor {
  id: string;
  name: string;
  legbal: number;
  contact?: string;
  details?: string;
  lastTransactionDate?: string;
}

// Get all employees for relief person selection
export const getAllEmployees = async () => {
  // console.log("Sending payload:", { requestID: requestID() });
  try {
    const response = await api.post(`/businesss/getAllStaffs2`, {
    // const response = await axios.post("/api/Users/getAllUserData", {
      requestID: requestID(),
      config,
    })
    console.log("API Response:", response)

    return response.data.data
    
  } catch (error) {
    console.error("Error fetching employees:", error)
    throw new Error("Failed to fetch employees")
  }
}

export const getAllCustomers = async () => {
  try {
    const response = await api.post(`users/getAllCustomersData`, {
    // const response = await axios.post("/api/Users/getAllUserData", {
      requestID: requestID(),
      config,
    })
    console.log("API Response:", response)
    return response.data.data
   
  } catch (error) {
    console.error("Error fetching employees:", error)
    throw new Error("Failed to fetch employees")
  }
}

export const getAllVendors = async () => {
  // console.log("Sending payload:", { requestID: requestID() });
  try {
    const response = await api.post(`users/getAllVendorData`, {
    // const response = await axios.post("/api/Users/getAllUserData", {
      requestID: requestID(),
      config,
    })
    console.log("API Response:", response)
    return response.data.data
    
  } catch (error) {
    console.error("Error fetching employees:", error)
    throw new Error("Failed to fetch employees")
  }
}

// In OutstandingAnalysisService.ts
export const sendReminder = async (
  id: string,
  type: 'customer' | 'vendor' | 'staff'
): Promise<void> => {
  // Example: You might POST to /reminders/send
  return fetch(`/api/reminders/send`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, type }),
  }).then((res) => {
    if (!res.ok) throw new Error('Failed to send reminder');
  });
};

export const sendBatchReminders = async (
  ids: string[],
  message: string,
  method: 'email' | 'sms' | 'both',
  type: 'customer' | 'vendor' | 'staff' | 'all'
): Promise<void> => {
  return fetch('/api/reminders/send-batch', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ids, message, sendMethod: method, type }),
  }).then((res) => {
    if (!res.ok) throw new Error('Batch reminder failed');
  });
};

